import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'

import Linker from '@/components/optypes/headlesss-components/Link'

// helper functions
import {
  returnValue,
  returnUserContent,
  returnBlockValue,
} from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
} from '@/utils/op-types/store'

const Block = ({ id, block, design, content }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  return (
    <div>
      <div className="">
        <div
          className="font-bold text-xl p-4 mb-3 inline-block transform -rotate-1	"
          style={{
            backgroundColor: returnBlockValue(
              'titlebgcolor',
              'design',
              opBlocks[block],
              design
            ),
            color: returnBlockValue(
              'titletextcolor',
              'design',
              opBlocks[block],
              design
            ),
          }}
        >
          {returnBlockValue('title', 'content', opBlocks[block], content)}
        </div>
        <div className="font-medium text-lg pl-4">
          {returnBlockValue('blurb', 'content', opBlocks[block], content)}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 px-4 mt-10">
        {returnBlockValue('links', 'content', opBlocks[block], content).map(
          (data, index) => (
            <Linker key={index} data={data.url} className="">
              <div
                className="transition-all transform hover:scale-105 cursor-pointer hover:shadow-xl rounded p-6 shadow mb-1.5"
                style={{
                  backgroundColor: returnValue(
                    'linkbgcolor',
                    opDesign,
                    pageDesign
                  ),
                  color: returnValue('linktextcolor', opDesign, pageDesign),
                }}
              >
                {data.url.meta.img && (
                  <div className="md:mr-4 flex-shrink-0">
                    <img
                      src={data.url.meta.img}
                      alt=""
                      className="w-full mb-4  rounded"
                    />
                  </div>
                )}
                <div className="w-full md:pr-6 flex-grow">
                  <div className="font-bold text-xl line-clamp-3">
                    {data.url.meta.title}
                  </div>
                  <div className="font-medium line-clamp-2 text-sm my-2 opacity-50">
                    {data.url.meta.desc}
                  </div>
                  <div
                    className="font-medium line-clamp-1 text-xs mt-1"
                    style={{
                      color: returnValue('linkurlcolor', opDesign, pageDesign),
                    }}
                  >
                    {data.url.url}
                  </div>
                </div>
              </div>
            </Linker>
          )
        )}
      </div>
    </div>
  )
}

export default Block
